import { processSplash } from '../processSplash';

import css from './assets/spinner.css';
import html from './assets/spinner.html';

export const spinner = processSplash(html, css);
